import React from 'react';
import PropTypes from 'prop-types';
import LabelSelector from '../LabelSelector';
import './LargeLabelSelector.css';

const LargeLabelSelector = ({ className = '', ...props }) => (
  <LabelSelector
    className={`cfg-large-label-selector ${className}`.trim()}
    {...props}
  />
);

LargeLabelSelector.propTypes = {
  children: PropTypes.node,
  selected: PropTypes.bool,
  disabled: PropTypes.bool,
  error: PropTypes.bool,
  favourite: PropTypes.bool,
  showValue: PropTypes.bool,
  showBooleans: PropTypes.bool,
  showYes: PropTypes.bool,
  showNo: PropTypes.bool,
  onClick: PropTypes.func,
  className: PropTypes.string,
};

export default LargeLabelSelector;